export default "/917096a3ddab128c0c409c1d13afb5f1.jpg";